<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ $route.params.id ? 'Editar' : 'Adicionar' }} Empresa
              </div>
            </div>

            <div class="card-body">
              <hr />
              <br />

              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent="save">
                    <div class="form-row">
                      <div class="form-group col-md-8">
                        <label for="companyName">
                          <span class="required">*</span> Nome da Empresa:
                        </label>

                        <input
                          autocomplete="off"
                          type="text"
                          id="companyName"
                          class="form-control"
                          v-model="company.name"
                          placeholder="Digite o nome da empresa"
                        />
                      </div>

                      <div class="form-group col-md-4">
                        <label>Status da Empresa</label><br>

                        <toggle-button
                          :sync="true"
                          v-model="statusToggle"
                          color="#15488A"
                          :height="25"
                        />

                        &nbsp;<b>{{ statusToggle ? "Ativo" : "Inativo" }}</b>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label>Checklists Avulsas</label><br>

                        <toggle-button
                          :sync="true"
                          v-model="checklistsAvulsasToggle"
                          color="#15488A"
                          :height="25"
                        />

                        &nbsp;<b>{{ checklistsAvulsasToggle ? "Habilitado" : "Desabilitado" }}</b>
                        <br>
                        <small class="text-muted">
                          Quando habilitado, usuários desta empresa poderão executar checklists sem agendamento
                        </small>
                      </div>
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>

                    <div class="block text-right">
                      <router-link to="/companies" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>

                      <button type="submit" class="btn btn-add">
                        Salvar
                        <i class="fa fa-save"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "companyAdd",

  data() {
    return {
      company: {
        name: "",
        status: 1,
        checklists_avulsas: 0,
      },
      errors: undefined,
    };
  },

  computed: {
    statusToggle: {
      get() {
        return this.company.status == 1 || this.company.status === true;
      },
      set(value) {
        this.company.status = value ? 1 : 0;
      },
    },
    checklistsAvulsasToggle: {
      get() {
        return this.company.checklists_avulsas == 1 || this.company.checklists_avulsas === true;
      },
      set(value) {
        this.company.checklists_avulsas = value ? 1 : 0;
      },
    },
  },

  methods: {
    makeFormData() {
      let fd = new FormData();

      fd.append("name", this.company.name);
      fd.append("status", this.company.status);
      fd.append("checklists_avulsas", this.company.checklists_avulsas);

      if (this.company.id) {
        fd.append("id", this.company.id);
        fd.append("_method", "PUT");
      } else {
        fd.append("_method", "POST");
      }

      return fd;
    },

    save() {
      let api = this.$store.state.api + "companies";
      let fd = this.makeFormData();

      if (this.company.id) {
        api += "/" + this.company.id;
      }

      axios
        .post(api, fd)
        .then(() => {
          this.$message("Sucesso", "Informações guardadas com sucesso", "success");
          this.$router.push("/companies");
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getCompany(id) {
      if (!id || id === "undefined") {
        return;
      }

      const api = this.$store.state.api + "companies/" + id;

      axios
        .get(api)
        .then((response) => {
          this.company = response.data.data[0];
          this.company.status =
            this.company.status == 1 || this.company.status === true ? 1 : 0;
          this.company.checklists_avulsas =
            this.company.checklists_avulsas == 1 || this.company.checklists_avulsas === true ? 1 : 0;
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },
  },

  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.getCompany(id);
    }
  },
};
</script>

<style scoped>
</style>
